// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"484":"cca4dcb88065c9ce","497":"2d0fcbfd9cee3afa","807":"b1c126739e5167f2","928":"c4e0f5f5c71352e9"}[chunkId] + ".js";
};